import settings from "../settings";

export const clanIsFull = clan => clan.members_count >= clan.maxMembersCount;

export const clanCost = () => settings.clanCreate.cost - settings.clanCreate.discount;